import React, { useContext, useCallback, memo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { history } from '../../history';
import { UserContext } from '../../context';
import { FiLogOut } from 'react-icons/fi';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../styles.css';

const Menu = memo(() => {
  const context   = useContext(UserContext);
  const logado    = context.isLogger;
  const userRole  = localStorage.getItem('user-role');
  const userName  = localStorage.getItem('user-name') || '';
  const isMaster  = userRole === 'MASTER';
  
  // ✅ Hook chamado sempre, antes de qualquer condicional
  const location = useLocation(); // Removida a verificação condicional

  const logout = useCallback(() => {
    localStorage.removeItem('delphireact-token');
    localStorage.removeItem('user-role');
    localStorage.removeItem('user-name');
    context.alterLogin(false);
    history.push('/login');
  }, [context]);

  if (!logado) return null;

  const initials = userName
    .split(' ')
    .slice(0, 2)
    .map(w => w[0])
    .join('')
    .toUpperCase() || 'U';

  const links = [
    { to: '/',          label: 'Home' },
    { to: '/pdv',       label: 'PDV' },
    { to: '/lics',      label: 'Licenças' },
    { to: '/ver',       label: 'Versões' },
    { to: '/csapi',     label: 'Produtos AZ' },
    ...(isMaster ? [
      { to: '/auditoria', label: 'Auditar' },
      { to: '/update',    label: 'Update' },
    ] : []),
  ];

  return (
    <nav className="cs-navbar">
      {/* Brand */}
      <a className="cs-navbar-brand" href="/">
        <div className="cs-logo-icon">C</div>
        <div>
          Compsoft
          <span className="cs-sub">Sistemas e Automação</span>
        </div>
      </a>

      <div className="cs-nav-divider" style={{ marginLeft: 20 }} />

      {/* Links de navegação */}
      <ul className="cs-nav-links">
        {links.map(({ to, label }) => (
          <li key={to}>
            <Link
              className={`cs-link ${location.pathname === to ? 'active' : ''}`}
              to={to}
            >
              {label}
            </Link>
          </li>
        ))}
      </ul>

      <div className="cs-nav-divider" />

      {/* Usuário + Sair */}
      <div className="cs-user-badge">
        <div className="cs-avatar">{initials}</div>
        <span className="cs-uname">{userName || 'Usuário'}</span>
      </div>

        <button
        className="cs-link cs-link-btn ms-3"
        onClick={logout}
        title="Sair da aplicação"
        style={{ 
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          color: 'rgba(255,255,255,.7)',
          fontSize: '13px',
          fontWeight: '500',
          padding: '6px 12px',
          borderRadius: '6px',
          transition: 'all 0.2s ease',
          border: '1px solid rgba(255,255,255,0.15)',
          backgroundColor: 'rgba(255,255,255,0.05)'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.color = '#fff';
          e.currentTarget.style.backgroundColor = 'rgba(239, 68, 68, 0.8)'; // Vermelho suave ao passar o rato
          e.currentTarget.style.borderColor = 'transparent';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.color = 'rgba(255,255,255,.7)';
          e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.05)';
          e.currentTarget.style.borderColor = 'rgba(255,255,255,0.15)';
        }}
      >
        <FiLogOut size={16} />
        <span>Sair</span>
      </button>
    </nav>
  );
});

export default Menu;